export const iconFontAwesomeCodingFolder = (
	<i className="fa-solid fa-folder"></i>
);
